// extracted by mini-css-extract-plugin
export default {"cls1":"PostPrompt-cls1___ddec688c38b731487c6","cls2":"PostPrompt-cls2__aa7736fd155541994527 PostPrompt-cls1___ddec688c38b731487c6"};